import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { reactErrorHandler } from '@sentry/react';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'), {
	onUncaughtError: reactErrorHandler(),
	onCaughtError: reactErrorHandler(),
	onRecoverableError: reactErrorHandler(),
});

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
);
